import { useEffect, useState } from "react";
import { _CostAnalysis, _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../theme/Component/BasicPage"
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import usePaginator from "../../theme/Component/usePaginator";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { Modal } from "../../theme/Component/Modal";
import { InputDate } from "../../theme/Input/InputDate";
import { SelectTHConstantsValue } from "../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputMoney } from "../../theme/Input/InputMoney";
import { SelectMonths } from "../../contract/select/SelectMonths";
import { ImportRegistry } from "./ImportRegistry";
import { PrintJson } from "../../theme/Component/PrintJson";
import { GenericItem } from "./GenericItem";
import { SignList } from "../OptionComponents/SignList/SignList";
import { NationalizationPhoto } from "../OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";
import { BasicButton } from "../../theme/Component/BasicButton";
import { MultipleNotes } from "../../theme/Component/MultipleNotes";

type filterProps = {
    Year: number;
    State: number;
    ContractNumber: string;
    CompanyName: string;
    ContractObject: string;
}

export const CostAnalysis = () => {

    const { bean, setBean, lista, setLista, instance, handleChange, isMissing, isRequired } = useDataBean(_CostAnalysis);
    const importRegistry = useDataBean(_ImportRegistry);
    const paginador = usePaginator();

    const formType = [
        { id: 100, name: 'Contrato' },
        { id: 200, name: 'Donación' }
    ];

    const [filter, setFilter] = useState<Partial<filterProps>>({
        Year: _single.getCurrenYear(),
        State: 1,
    })

    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const modalItem = useModal("Items", MODAL_LG);
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalImgs = useModal(`Registros fotograficos de ${bean.ContractNumber}`, MODAL_LG);
    const modalSigns = useModal(`Firmas de ${bean.ContractNumber}`, MODAL_LG);
    const modalExcel = useModal(`Reporte de ${bean.ContractNumber}`, MODAL_LG);

    const head = [
        { title: 'No', property: 'IDCostAnalysis', mask: MASK_NUMBER },
        { title: 'Tipo de Registro', property: 'TypeRegisterName' },
        { title: 'Contrato / Donación', property: 'ContractNumber' },
        { title: 'Objeto de Contrato', property: 'ContractObject', visible: false, Style: { minWidth: "350px" } },
        { title: 'Fecha Estudio Costos', property: 'DateEC' },
        { title: 'Empresa', property: 'CompanyName' },
        { title: 'Lugar de Entrega', property: 'DeliveryPlaceEC' },
        { title: 'Plazo Entrega', property: 'LeadTime' },
        { title: 'Mes Proyectado', property: 'MonthProjectetStr' },
        { title: 'Tasa de Cambio', property: 'ExchangeRateEC', mask: MASK_NUMBER },
        { title: 'Descripción Mercancia', property: 'GoodsDescription' },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItem.open() } },
            { titulo: 'Descargar Reporte en Excel', icono: 'ri-file-excel-line', visible: _single.canEdit(), evento: () => { getExcel(); } },
            { titulo: 'Firmas', icono: 'ri-quill-pen-line', visible: _single.canEdit(), evento: () => { modalSigns.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        getCostAnalisys();
    }, [paginador.page])

    const getCostAnalisys = () => {
        importRegistry.instance.getFormRegistryRender(importRegistry.instance.COSTANALYSIS, paginador.page, 15, _single.cleanMap(filter))
            .then((resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }).catch(err => toast.error(err))
    }

    const addItem = () => {
        setBean({ 
            State: 1,
            IDEmployee: _single.getAccountID(),
            DateEC: _single.getCurrenDate(),
        });
        modalEdit.open();
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        importRegistry.instance.getFormatExcelByForm(bean.IDCostAnalysis, _single.getAccountID(), importRegistry.instance.COSTANALYSIS).then(
            (resp: any) => {
                const document = resp?.Document?.DataBeanProperties
                    ?? resp?.DataBeanProperties?.Document?.DataBeanProperties;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            const message = err?.message ?? String(err ?? "Error desconocido al generar el archivo");
            setExcelError(message);
            modalExcel.open();
        })
    }

    const editaItem = (obj: any) => {
        instance.updateCustonBean({ ...obj, IDEmployee: _single.getAccountID() }).then(
            (resp: any) => {
                toast.success("Datos Guardados Correctamente");
                modalEdit.close();
                getCostAnalisys();
            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <BasicPage titulo="Estudio de Costos">
            <div className="row ">
                <div className="col-md-4">
                    <label>Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractNumber} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Empresa</label>
                    <input type="text" className="form-control" value={filter.CompanyName} onChange={(e) => { setFilter({ ...filter, CompanyName: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Objeto del Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractObject} onChange={(e) => { setFilter({ ...filter, ContractObject: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getCostAnalisys() }} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} records={paginador}></BasicTable>
                    {/* <PrintJson json={lista}/> */}
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('IDImportRegistry') ? 'has-error' : ''}`}>Contrato / Donacion {isRequired('IDImportRegistry') ? <span className="text-danger">*</span> : ''}</label>
                                <ImportRegistry label=" " editor={true} idSelector={bean.IDImportRegistry} onChange={(e) => { setBean({ ...bean, IDImportRegistry: e.IDImportRegistry }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="DateEC" value={bean.DateEC} onChangeE={(e) => { setBean({ ...bean, DateEC: e }) }} label="Fecha Estudio" />
                            </div>
                            <div className="col-md-6">
                                <label>Empresa / Firma</label>
                                <input type="text" name="SingContract" value={bean.SingContract} onChange={handleChange} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <SelectTHConstantsValue label="Forma de Pago" value={bean.IDPaymentTypePS} code={10000} onChange={(e) => { setBean({ ...bean, IDPaymentTypePS: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Lugar de Entrega</label>
                                <input type="text" name="DeliveryPlaceEC" value={bean.DeliveryPlaceEC} onChange={handleChange} className="form-control" />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _style="decimal" _value={bean.ExchangeRateEC} _label="Tasa de Cambio" onChange={(e) => { setBean({ ...bean, ExchangeRateEC: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputMoney _style="decimal" _value={bean.ForpoComission} _label="Comisión Forpo" onChange={(e) => { setBean({ ...bean, ForpoComission: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="LeadTime" label="Plazo de Entrega" value={bean.LeadTime} onChangeE={(e) => { setBean({ ...bean, LeadTime: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectMonths idSelector={bean.ProjectedMonth} onChange={(e) => { setBean({ ...bean, ProjectedMonth: e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label >Descripcion de la mercancia</label>
                                <textarea name="GoodsDescription" value={bean.GoodsDescription} onChange={handleChange} className="form-control"></textarea>
                            </div>
                            <div className="col-md-12">
                                <label >Notas</label>
                                <MultipleNotes
                                    label=" "
                                    notes={bean.NotesEC}
                                    onChange={(notes) => {
                                        setBean({ ...bean, NotesEC: JSON.stringify(notes) });
                                    }}
                                />
                                {/* <textarea name="NotesEC" value={bean.NotesEC} onChange={handleChange} className="form-control"></textarea> */}
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteItem(); }}>
                        Eliminar Estudio de Costos {bean.IDCostAnalysis} - {bean.ContractNumber}
                    </ModalConfirm>

                    <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                        <GenericItem typeForm={importRegistry.instance.COSTANALYSIS} formBean={bean} />
                    </Modal>

                    <Modal modal={modalImgs.modal} updateModal={modalImgs.setModal} >
                        <NationalizationPhoto isModal idFormType={bean.IDCostAnalysis} formType={_ImportRegistry.COSTANALYSIS} />
                    </Modal>

                    <Modal modal={modalSigns.modal} updateModal={modalSigns.setModal} >
                        <SignList isModal idFormType={bean.IDCostAnalysis} formType={_ImportRegistry.COSTANALYSIS} />
                    </Modal>

                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <DownloadFileCard
                                    file={excelDocument}
                                    error={excelError}
                                    fallbackName="Reporte.xlsx"
                                    fileTypeLabel="Archivo Excel"
                                    buttonLabel="Descargar Excel"
                                    icon="ri-file-excel-2-line"
                                    iconClassName="text-success"
                                    buttonClassName="btn-success"
                                />
                            </div>
                        </div>
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
